function MockedDecorator() {
  return function () {};
}

export const ApiProperty = MockedDecorator;
